module.exports = __webpack_public_path__ + "img/img-visa.cb421edc.svg";